///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2022 - 2022
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { forEach, groupBy, sumBy } from "lodash";

import { round } from "./laneCalculations";
import { analyticsFilterRankTypes } from "./types";

const mapRankByVolumeGraphDetails = loads => {
  const data = [];
  if (loads && loads.length) {
    forEach(
      groupBy(loads, l => l.rank),
      (value, key) =>
        data.push({
          name: analyticsFilterRankTypes.find(x => x.value === parseInt(key))
            .label,
          volume: value.length,
          averageCost: round(sumBy(value, "cost") / value.length),
          averageCpm: round(sumBy(value, "cost") / sumBy(value, "miles"))
        })
    );
  }
  return data;
};

export default mapRankByVolumeGraphDetails;
